import { api } from '@/utils/api';

/**
 * Refresh every list on the done-for-you Replies page (Received, Engaged
 * Waiting, All Waiting). The page mounts all three queries at once, so a
 * mutation that changes what a row renders (stage badge, prefilter chip,
 * ack state) must invalidate all three or the tabs drift out of sync
 * (POS-2516). Note: queueing a reply does not move the contact to a Waiting
 * tab until the worker actually sends it and records `we_replied_on`.
 */
export const useInvalidateDoneForYouReplyLists = () => {
  const utils = api.useUtils();
  return async (filter?: { userId: string; teamId: string }) => {
    await Promise.all([
      utils.superAdmin.doneForYouUserResponses.invalidate(filter),
      utils.superAdmin.doneForYouUserWaitingForReply.invalidate(filter),
      utils.superAdmin.doneForYouUserWaitingForReReply.invalidate(filter),
    ]);
  };
};

export const useReorderDoneForYouMutation = () => {
  const utils = api.useUtils();

  return api.superAdmin.reorderDoneForYou.useMutation({
    onSuccess: async () => {
      await utils.superAdmin.doneForYouUsers.invalidate();
    },
  });
};

export const useCreateDoneForYouBucketMutation = () => {
  const utils = api.useUtils();

  return api.superAdmin.createDoneForYouBucket.useMutation({
    onSuccess: async () => {
      await utils.superAdmin.doneForYouUsers.invalidate();
    },
  });
};

export const useDeleteDoneForYouBucketMutation = () => {
  const utils = api.useUtils();

  return api.superAdmin.deleteDoneForYouBucket.useMutation({
    onSuccess: async () => {
      await utils.superAdmin.doneForYouUsers.invalidate();
    },
  });
};

export const useUpdateDoneForYouBucketMutation = () => {
  const utils = api.useUtils();

  return api.superAdmin.updateDoneForYouBucket.useMutation({
    onSuccess: async () => {
      await utils.superAdmin.doneForYouUsers.invalidate();
    },
  });
};

export const useGenerateVoiceDropAppendsMutation = () => {
  const utils = api.useUtils();

  return api.superAdmin.generateVoiceDropAppends.useMutation({
    onSuccess: async () => {
      await utils.superAdmin.userTeam.invalidate();
    },
  });
};

export const useDismissReplyMutation = () => {
  const invalidateReplyLists = useInvalidateDoneForYouReplyLists();

  return api.superAdmin.dismissReply.useMutation({
    onSuccess: async (_data, variables) => {
      await invalidateReplyLists({ userId: variables.userId, teamId: variables.teamId });
    },
  });
};
